import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'microbiologics',
} as IModuleProps;
